import type { FC } from 'react';
import { useMemo } from 'react';
import type { MenuItemVariantDto } from '../../../../generated-api';
import Item from './Item';

interface Props {
  items: MenuItemVariantDto[];
  isClosed: boolean;
}

const Items: FC<Props> = ({ items, isClosed }) => {
  const itemsList = useMemo(
    () => items.map((item) => <Item key={item.variantLinkId} item={item} isClosed={isClosed} />),
    [items, isClosed]
  );

  return <section className="grid grid-cols-12 auto-rows-min gap-4">{itemsList}</section>;
};
export default Items;
